module.exports = __webpack_public_path__ + "img/diy-BkBcUuJu.3234965f.svg";